import HowItWorksStepCard from "@/design-system/Molecules/HowItWorksStepCard";
import { OralMedGeneralStepCardData } from "@/design-system/Molecules/HowItWorksStepCard/stepCard.config"


export const OralMedGeneralStepCard = () => {
  return (  
      <section className="relative  py-[4.68rem] lg:py-40"> 
      <div className="container mx-auto px-4">
        <div className="bg-[#f6f7f9] rounded-[20px]">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 items-stretch p-[30px]">
            {OralMedGeneralStepCardData.map((step, idx) => (
              <HowItWorksStepCard
                key={idx}
                icon={step.icon ?? ""}
                title={step.title ?? ""}
                description={step.description ?? ""}
                className={step.className ?? ""}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OralMedGeneralStepCard;
